"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let BtnSyncResource = class BtnSyncResource extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "usercontrol",
    };
    beforeCreate() {
    }
    resource;
    onResource(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("resource");
    }
    headerMessage;
    onHeader_message(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("headerMessage");
    }
    confirmMessage;
    onConfirm_message(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("confirmMessage");
    }
    btnOK;
    onBtn_ok(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("btnOK");
    }
    size;
    onSize(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("size");
    }
    target;
    onTarget(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("target");
    }
    messages;
    ux;
    dataMembers = ['messages', 'ux'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                messages: {
                    text: this.$fn.pgettext("BtnDeleteResource", "Delete"),
                },
                ux: null,
            },
        };
    }
    get synced() {
        if (this.loaded) {
            return !!(this.resource.sync_status || this.resource.external_key);
        }
        return null;
    }
    get tooltipMessage() {
        if (this.loaded) {
            return this.synced ?
                `Szinkronizálva [${this.resource.external_key}]` :
                'Szinkronizálás';
        }
        return null;
    }
    async act_7315092382398562_emit_2392_getActionArgs($event) {
        return {
            event: "success",
        };
    }
    async act_7315092382398562_request_2390_getActionArgs($event) {
        return {
            operation: 'sync_' + this.resource.object,
            data: { id: this.resource.id, target: this.target || 'irent' },
        };
    }
    async act_7315092382398562_request_2390_getConfirm($event) {
        return {
            header: this.headerMessage,
            message: this.confirmMessage,
            btnOk: this.btnOK,
            btnCancel: "Mégsem",
            severity: "warning",
        };
    }
    async evh_7315092382398562_clickPreventStop(event, scope) {
        return await this.actions.evh_7315092382398562_clickPreventStop.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_7315092382398562_emit_2392 = new core_1.actions.EmitAction({
            actionArgs: this.act_7315092382398562_emit_2392_getActionArgs,
            events: [],
        });
        const evh_7315092382398562_success_2391 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_emit_2392,
            event: "success",
            displayName: "emit",
        });
        const act_7315092382398562_request_2390 = new core_1.actions.RequestAction({
            actionArgs: this.act_7315092382398562_request_2390_getActionArgs,
            confirm: this.act_7315092382398562_request_2390_getConfirm,
            displayName: "sync",
            events: [evh_7315092382398562_success_2391],
        });
        const evh_7315092382398562_clickPreventStop_2389 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_request_2390,
            event: "click.prevent.stop",
            displayName: "sync",
        });
        const evh_7315092382398562_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_clickPreventStop_2389],
        });
        return {
            act_7315092382398562_emit_2392,
            evh_7315092382398562_success_2391,
            act_7315092382398562_request_2390,
            evh_7315092382398562_clickPreventStop_2389,
            evh_7315092382398562_clickPreventStop,
            sync: act_7315092382398562_request_2390,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        required: true,
        type: Object,
    }),
    __metadata("design:type", Object)
], BtnSyncResource.prototype, "resource", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('resource'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], BtnSyncResource.prototype, "onResource", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
        default: "IntegroRent szinkronizálás",
    }),
    __metadata("design:type", String)
], BtnSyncResource.prototype, "headerMessage", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('headerMessage'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], BtnSyncResource.prototype, "onHeader_message", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
        default: "Adatok visszaírása az IntegroRent rendszerébe?",
    }),
    __metadata("design:type", String)
], BtnSyncResource.prototype, "confirmMessage", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('confirmMessage'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], BtnSyncResource.prototype, "onConfirm_message", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
        default: "Szinkronizálás",
    }),
    __metadata("design:type", String)
], BtnSyncResource.prototype, "btnOK", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('btnOK'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], BtnSyncResource.prototype, "onBtn_ok", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
    }),
    __metadata("design:type", String)
], BtnSyncResource.prototype, "size", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('size'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], BtnSyncResource.prototype, "onSize", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
        default: "irent",
    }),
    __metadata("design:type", String)
], BtnSyncResource.prototype, "target", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('target'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], BtnSyncResource.prototype, "onTarget", null);
BtnSyncResource = __decorate([
    (0, vue_property_decorator_1.Component)()
], BtnSyncResource);
exports.default = BtnSyncResource;
vue_property_decorator_1.Vue.component("BtnSyncResource", BtnSyncResource);
